import { Component, Input } from "@angular/core"
import { UserService } from "../../../services/user.service"
import { ModalService } from "../../modal/modal.service"
import { AuthModalComponent } from "../../modals/auth-modal/auth-modal.component"
import { StudentLoginModalComponent } from "../../modals/student-login-modal/student-login-modal.component"
import { StudentSignupModalComponent } from "../../modals/student-signup-modal/student-signup-modal.component"

@Component({
    selector: "app-register",
    templateUrl: "./register.component.html",
    styleUrls: ["./register.component.scss"],
})
export class RegisterComponent {
    @Input() public showSocialIcons: boolean = true
    @Input() public text: string = null
    @Input() public student: boolean = false
    @Input() public nextURL: string = null
    @Input() public mobile: boolean = false

    constructor(private modalService: ModalService, public userService: UserService) {}

    public openAuthModal() {
        this.modalService.open(AuthModalComponent, {
            data: {
                nextURL: this.nextURL,
            },
        })
    }

    public openStudentAuthModal() {
        this.modalService.open(StudentLoginModalComponent, {
            data: {
                nextURL: this.nextURL,
            },
        })
    }

    public openStudentRegistrationModal() {
        this.modalService.open(StudentSignupModalComponent, { size: "lg" })
    }

    public setWidth() {
        if (this.text) {
            return { width: "auto" }
        }
    }
}
